var dinoIcon = "https://shopfront-cdn.tekoapis.com/static/fc13827d222b8c0d.svg";

export { dinoIcon as default };
